import { useState, useEffect } from "react";
import { getRetry } from "../lib/api";
import { useStore } from "../context/StoreContext";
import { CourseCard } from "../components/CourseCard";
import { Star, Users, BookOpen, MessageSquare, Youtube, Twitter } from "lucide-react";

export default function InstructorPage() {
  const { sections } = useStore();
  const [p, setP] = useState(null);
  useEffect(() => { getRetry("/instructor").then((r) => setP(r.data)).catch(() => setP(false)); }, []);
  if (p === null) return <p className="p-10 pt-32 text-center text-[var(--forge-dim)]">Loading…</p>;
  if (p === false) return <p className="p-10 pt-32 text-center text-[var(--forge-dim)]">Couldn't load profile.</p>;
  const secMap = Object.fromEntries(sections.map((s) => [s.id, s]));
  const stats = [
    [Star, `${p.stats.rating || "—"}`, "AVG RATING"],
    [MessageSquare, p.stats.reviews, "REVIEWS"],
    [Users, p.stats.students, "STUDENTS"],
    [BookOpen, p.stats.courses, "COURSES"],
  ];
  return (
    <div className="instructor-page wrap" data-testid="instructor-page">
      <div className="inst-hero">
        <div className="inst-hero-av">{p.name.slice(0, 1)}</div>
        <div className="inst-hero-info">
          <p className="eyebrow">◆ YOUR INSTRUCTOR ◆</p>
          <h1 data-testid="instructor-name">{p.name}</h1>
          <p className="headline">{p.headline}</p>
          <div className="inst-hero-stats">
            {stats.map(([Icon, val, label]) => (
              <div key={label} className="ihs">
                <Icon size={15} style={{ color: "var(--gold)" }} />
                <b>{val}</b><span>{label}</span>
              </div>
            ))}
          </div>
          {(p.youtube || p.twitter || p.discord) && (
            <div className="inst-socials">
              {p.youtube && <a href={p.youtube} target="_blank" rel="noreferrer" data-testid="instructor-youtube"><Youtube size={15} /> YouTube</a>}
              {p.twitter && <a href={p.twitter} target="_blank" rel="noreferrer" data-testid="instructor-twitter"><Twitter size={15} /> X</a>}
              {p.discord && <a href={p.discord} target="_blank" rel="noreferrer" data-testid="instructor-discord">Discord</a>}
            </div>
          )}
        </div>
      </div>
      <p className="inst-bio" data-testid="instructor-bio">{p.bio}</p>
      <h2 className="inst-courses-title">ALL COURSES ({p.courses.length})</h2>
      <div className="sec-grid">
        {p.courses.map((c) => <CourseCard key={c.id} c={c} secMap={secMap} />)}
      </div>
    </div>
  );
}
